import React, { Component } from 'react'
import '../../../styles/checkout/mainStyle.css'
import { selectMode } from '../../../actions/commonActions'
import { connect } from 'react-redux'

const isIE = /*@cc_on!@*/false || !!document.documentMode;

export class Production extends Component {
    componentDidMount() {
        this.props.selectMode('integration_guide');
    }

    state = {
        topRef: React.createRef()
    }

    onScrollToTop() {
        this.state.topRef.current.scrollIntoView()
        window.document.body.scrollIntoView(true)
    }

    render() {
        return (
            <div   className= "stepPageContainer">  
                <h3 ref={this.state.topRef} className="stepPageTitle">Moving to Production with MCO</h3>
                <div>
                    <p>Once you have finished testing your Moneris Checkout integration, do the following to move the integration into production:</p>
                    <ol style={{paddingInlineStart: "20px", paddingLeft: isIE ? '2vw' : ''}}>
                        <li>Ensure that you have duplicated your final testing configuration in your Moneris Checkout production configuration in the production Merchant Resource Center at <a href="https://www3.moneris.com/mpg" target="_blank" rel="noopener noreferrer">https://www3.moneris.com/mpg</a> <br /><br /></li>
                        <li>Use the production URL for server to server requests:<br />
                            <a href="https://gateway.moneris.com/chktv2/request/request.php" target="_blank" rel="noopener noreferrer">https://gateway.moneris.com/chktv2/request/request.php</a>
                            <br /><br />
                        </li>
                        <li>Use the production JavaScript library:<br />
                            <pre><span id="code6">&lt;script src="https://gateway.moneris.com/chktv2/js/chkt_v2.00.js"&gt;&lt;/script&gt;</span></pre>
                        </li>
                        <li>Set up your myCheckout object to the production mode:<br />
                            <pre><span id="code7">myCheckout.setMode("prod");</span></pre>
                        </li>
                        <li>In all Preload requests use the value "prod" for the environment variable.<br /><br /></li>
                        <li>In all Preload requests, make sure that you are using the production version of your credentials for <b>Store ID</b>, <b>API token</b> and <b>Checkout ID</b>.<br /><br /></li>
                        <li>In all Receipt requests use the value "prod" for the environment variable.<br /><br /></li>
                        <li>In all Receipt requests, make sure that you are using the production version of your credentials for <b>Store ID</b>, <b>API token</b> and <b>Checkout ID</b>.</li>
                    </ol>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    const { mode } = state.common.sideNav;
    return { mode};
  }

export default connect(mapStateToProps,{selectMode})(Production)
